import EventData from '../event/event-data';
import EventListener from '../event/event-listener';

import Mountable from './mountable';

interface KeyboardEventArgs {
  readonly altKey: boolean;
  readonly cancelable: boolean;
  /**
   * @deprecated
   * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/charCode
   */
  readonly charCode: number;
  readonly ctrlKey: boolean;
  readonly key: string;
  /**
   * @deprecated
   * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/keyCode
   */
  readonly keyCode: number;
  readonly oldValue: any;
  readonly shiftKey: boolean;
  readonly value: any;

  preventDefault(): void;
  stopImmediatePropagation(): void;
  stopPropagation(): void;
}

class KeyboardEvent extends EventData<Keyboardable> implements KeyboardEventArgs {

  readonly altKey: boolean;
  readonly cancelable: boolean;
  /**
   * @deprecated
   * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/charCode
   */
  readonly charCode: number;
  readonly ctrlKey: boolean;
  readonly key: string;
  /**
   * @deprecated
   * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/keyCode
   */
  readonly keyCode: number;
  readonly oldValue: any;
  readonly shiftKey: boolean;
  readonly value: any;

  preventDefault: () => void;
  stopImmediatePropagation: () => void;
  stopPropagation: () => void;

  constructor({
    altKey,
    cancelable,
    charCode,
    ctrlKey,
    key,
    keyCode,
    oldValue,
    preventDefault,
    shiftKey,
    stopImmediatePropagation,
    stopPropagation,
    value,
  }: KeyboardEventArgs) {
    super();

    this.altKey = altKey;
    this.cancelable = cancelable;
    this.charCode = charCode;
    this.ctrlKey = ctrlKey;
    this.key = key;
    this.keyCode = keyCode;
    this.oldValue = oldValue;
    this.preventDefault = preventDefault;
    this.shiftKey = shiftKey;
    this.stopImmediatePropagation = stopImmediatePropagation;
    this.stopPropagation = stopPropagation;
    this.value = value;
  }
}

class KeyboardEventListener extends EventListener<Keyboardable, KeyboardEvent, KeyboardEventArgs> {
  constructor() {
    super(KeyboardEvent);
  }
}

export default interface Keyboardable extends Mountable {

  /** @event */
  onKeyDown: KeyboardEventListener;

  /** @event */
  onKeyPress: KeyboardEventListener;

  /** @event */
  onKeyUp: KeyboardEventListener;

}

export { KeyboardEventListener, KeyboardEvent };
